import React from 'react'

import { CardContainer, CardTitle, CardText } from './styles'

const CardSimples = ({ card }) => {
  const { titulo, descricao } = card
  return (
    <CardContainer>
      <CardTitle>{titulo}</CardTitle>
      <CardText>{descricao}</CardText>
    </CardContainer>
  )
}

export default CardSimples
